import React, { useState, useEffect } from "react";
import CustomTable from "../../../../customComponents/CustomTable";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import { TABLE_HEADERS, keyMapping } from "../../../../../constants/ActionToBeTaken"; 
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../../customComponents/CustomLoader";

const ActionToBeTakenList = () => {
  const [actionToBeTaken, setActionToBeTaken] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)

  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchActionToBeTaken(newPage);
  };
  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITACTIONTOBETAKEN}`, { state: { data: rowData } });
   
  }

  const fetchActionToBeTaken = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "/actiontobetaken/list",
        {
          orderBy: "action_tobe_taken_id desc",
          page,
          pageSize,
          searchText:searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords

      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setActionToBeTaken(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error("Error fetching action to be taken list:", error);
    }
    finally{
      setLoading(false)
    }
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchActionToBeTaken();
    }
  }, [searchTerm]);

  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className="OnboardManagamentContainer">
        <div className="OnboardManagamentbuttonContainer">
          <h5>Action To Be Taken Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalData} </h5>
            <h6>All Records</h6>
          </div>
          <div className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText" >{totalActive} </h5>
            <h6>Active Records</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText" >{totalInactive} </h5>
            <h6>Inactive Records</h6>
          </div>
          <button
            className="addcustomerbutton"
            onClick={() =>
              navigate(ROUTES_NAVIGATION.ADDACTIONTOBETAKEN)
            }
          >
            Add Action To Be Taken
          </button>
        </div>
      </div>

      <div className="tableWrapper">
        <div className="admin-list-container">
        <div className='listsearchContainer'>
          <h5>Action to be taken List</h5>
          <div>
              <SearchInput
                placeholder="Search Action To Be Taken"
                onSearch={fetchActionToBeTaken}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        </div>

        <CustomTable
          data={actionToBeTaken}
          headers={TABLE_HEADERS}
          keyMapping={keyMapping}
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit}
          totalRecords={totalRecords} 
        />
      </div>
    </div>
      )}
  </div>
  );
};

export default ActionToBeTakenList;
